/**
 * tutorRoutes — TabKey ↔ noms de route des onglets de l'espace tuteur.
 *
 * Les noms de route sont ceux des onglets legacy (`tutorTabScreens.js`) : un `navigate("proposals")`
 * écrit ailleurs dans l'app, et les liens `menu/proposals` ou `menu/dashboard` d'un mail ou d'une
 * notification, atterrissent au même endroit des deux côtés de l'interrupteur.
 */
import { type TabKey } from "../../../../../design-system"
import { type TutorSpaceTabName } from "./tutorSpaceRouteTypes"

export type TutorTabKey = Extract<TabKey, "dashboard" | "students" | "proposals" | "tutorResources">

export const TUTOR_TAB_KEY_TO_ROUTE: Record<TutorTabKey, TutorSpaceTabName> = {
    dashboard: "dashboard",
    students: "students",
    proposals: "proposals",
    tutorResources: "tutor-resources",
}

/** Le titre de chaque onglet : sur le web, celui de la page (`App.js` lit `headerTitle`). */
export const TUTOR_TAB_TITLES: Record<TutorTabKey, string> = {
    dashboard: "Accueil",
    students: "Mes élèves",
    proposals: "Offres de cours",
    tutorResources: "Ressources pédagogiques",
}

export function routeNameToTutorTabKey(routeName: string): TutorTabKey | undefined {
    const entry = Object.entries(TUTOR_TAB_KEY_TO_ROUTE).find(([, route]) => route === routeName)
    return entry?.[0] as TutorTabKey | undefined
}
